import { render } from "./Adjustments.vue?vue&type=template&id=f4f4df70&scoped=true"
import script from "./Adjustments.vue?vue&type=script&lang=js"
export * from "./Adjustments.vue?vue&type=script&lang=js"

import "./Adjustments.vue?vue&type=style&index=0&id=f4f4df70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f4df70"]])

export default __exports__